<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cn4noL/tc-custom/9781507301234.jpg?1731796625710" alt="This image is the cover for the book If the Shoe Fits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If the Shoe Fits
      </h1>
      <p class="bookDescription body article font2">
        <p>Ever wonder what might have happened if a certain glass slipper had been placed on the wrong maiden's foot . . . and fit?! In this comic twist on a classic fairy tale, Murray, a humble shoemaker, presents a pair of glass slippers to the frantic fairy godmother when her wand runs out of power, setting off a rollicking chain of events that may force him to disappoint a prince, risk the fairy’s wrath, and sacrifice the secret love of his life. Deborah Guarino, author of the bestselling Is Your Mama a Llama?, has created a magical story that will delight readers of all ages. Vivid illustrations bring the characters brilliantly to life in this tale of true love, royal mayhem, and big feet.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Guarino, Seth Hippen
      </h2>
      
      <p class="authorDescription body article">Deborah Guarino is the bestselling author of the perennial children’s classic Is Your Mama a Llama?, which has now sold more than two million copies and been in print for 30 years. She is also an accomplished lyricist, copywriter, editor, actor, artist, and mother of two sons.  If the Shoe Fits is Seth Hippen's first foray into children's books. He spends most of his time making characters move through animation, so you may have seen his work on the silver screen a time or two.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing, Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e147cbe